import * as service from './service'
export default {
  namespace: 'WaitingVerified',
  state: {
    supplierData: {}
  },
  effects: {
    * getVerifiedData ({ payload }, { call, put }) {
      const res = yield call(service.list, payload)
      yield put({
        type: 'save',
        payload: {
          supplierData: res.data.data || {}
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
